import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header.jsx"
import MinecraftItemsList from "../../../Assets/MinecraftItemsList.json"
import Item from "./Item.jsx"
import style from "./style.module.css";

const Shop = ({ user }) => {

    const navigate = useNavigate();

    const [itemsBackup, setItemsBackup] = React.useState(MinecraftItemsList);
    const [items, setItems] = React.useState(MinecraftItemsList);
    const [cart, setCart] = React.useState([]);
    const [filter, setFilter] = React.useState("");
    const [finallPrice, setFinallPrice] = React.useState(0);

    React.useEffect(() => {

        setItems(() => itemsBackup.filter(item => item.item.toLowerCase().includes(filter.toLowerCase())));

    }, [filter]);

    React.useEffect(() => {

        let fnlPrice = cart.reduce((total, item) => {
            return total + (parseInt(item.amount) * 5);
        }, 0);
        setFinallPrice(fnlPrice);

    }, [cart]);

    const addToCart = (item) => {
        setCart(prevState => {
            const itemExists = prevState.find(cartItem => cartItem.id === item.id);

            if (itemExists) {
                return prevState.map(cartItem =>
                    cartItem.id === item.id
                        ? { ...cartItem, amount: parseInt(cartItem.amount) + parseInt(item.amount) }
                        : cartItem
                );
            } else return [...prevState, { ...item }];
        });
    };

    const handlePurchase = () => {
        setFilter("");
        setCart([]);
        setFinallPrice(0);
    };

    return (
        <>
            <Header auth={true} user={user}/>
            <div className={style.rootDiv}>
                <div className={style.content}>
                    <div className={style.filter}>
                        <input placeholder="SEARCH ITEM ..." value={filter} onChange={event => setFilter(event.target.value)}/>
                        <svg viewBox="0 0 512 512">
                            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                        </svg>
                    </div>
                    <div className={style.rightSide}>
                        <div className={style.shopingCart}>
                            <div className={style.shoppingCardTitle}>
                                <p>SHOPPING CART</p>
                                <svg viewBox="0 0 576 512">
                                    <path d="M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-85.6 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM192 304l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"/>
                                </svg>
                            </div>
                            <div className={style.header}>
                                <p>Title</p>
                                <p>Amount</p>
                                <p style={{marginLeft:"auto"}}>Price</p>
                                <p style={{width:"25px"}}></p>
                            </div>
                            <div className={style.scrollableCard}>
                                {cart && cart.map((item, index) => (
                                  <div key={index} className={style.cardRow}>
                                      <p>{item.item}</p>
                                      <p className={style.amount}>{item.amount}x</p>
                                      <p className={style.price}>{item.amount*5}$</p>
                                      <button onClick={() => setCart(prevState => prevState.filter(y => y.id !== item.id))}>x</button>
                                  </div>
                                ))}
                            </div>
                        </div>
                        <button onClick={handlePurchase} className={style.confirmBtn}>
                            <p>CONFIRM PURCHASE</p>
                            <p className={style.finallPrice}>COST {finallPrice} $</p>
                        </button>
                    </div>
                    <div className={style.scrollList}>
                        {items.map((item, index) => (
                          <Item key={index} item={item} addToCart={addToCart}/>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Shop;